$('body').on('click', '.input-pass-eye .toggle-eye', function (e) {
    let password = $(this).parent().find('input');

    if (password.attr('type') === 'password') {
        password.attr('type', 'text');
        $(this).find('.eye').addClass('hidden');
        $(this).find('.eye-closed').removeClass('hidden');
    } else {
        password.attr('type', 'password');
        $(this).find('.eye').removeClass('hidden');
        $(this).find('.eye-closed').addClass('hidden');
    }
});
